module.exports = __webpack_public_path__ + "static/OR3-56f434dbf54ef737a49411a481577ee7.jpg";